var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i]
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
      }
    return __assign.apply(this, arguments)
  }
var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {}
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p]
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]]
      }
    return t
  }
import classNames from 'classnames'
import React from 'react'
import { ODIcon } from '../../icons'
import { ODInputGuideText } from './ODInputGuideText'
var ODPrependIcon = function (props) {
  var prependIcon = props.prependIcon
  return React.createElement(
    'div',
    { className: 'pl-3 pointer-events-none' },
    React.createElement(ODIcon, { icon: prependIcon })
  )
}
export var ODInput = function (props) {
  var id = props.id,
    placeholder = props.placeholder,
    value = props.value,
    onChange = props.onChange,
    prependIcon = props.prependIcon,
    guideText = props.guideText,
    onEnter = props.onEnter,
    _a = props.styleWrapper1,
    styleWrapper1 = _a === void 0 ? {} : _a,
    _b = props.noPadding,
    noPadding = _b === void 0 ? false : _b,
    _c = props.inputProps,
    inputProps = _c === void 0 ? {} : _c,
    cnProps = __rest(props, [
      'id',
      'placeholder',
      'value',
      'onChange',
      'prependIcon',
      'guideText',
      'onEnter',
      'styleWrapper1',
      'noPadding',
      'inputProps',
    ])
  var cn = classNames('od-input', cnProps, { pl7: !!prependIcon })
  var cnWrapper = classNames('od-input-wrapper', {
    success: cnProps.success,
    error: cnProps.error,
  })
  var handleKeydown = function (e) {
    var _a
    if (e.key === 'Enter') {
      ;(_a = onEnter) === null || _a === void 0 ? void 0 : _a()
      e.preventDefault()
    }
  }
  var cnWrapper1 = classNames({ 'px-2': !noPadding, 'py-1': !noPadding })
  return React.createElement(
    'div',
    { className: cnWrapper1, style: styleWrapper1 },
    React.createElement(
      'div',
      { className: cnWrapper },
      prependIcon && React.createElement(ODPrependIcon, { prependIcon: prependIcon }),
      React.createElement(
        'input',
        __assign(
          {
            id: id,
            disabled: cnProps.disabled,
            className: cn,
            placeholder: placeholder,
            value: value,
            onChange: onChange,
            onKeyPress: handleKeydown,
          },
          inputProps
        )
      )
    ),
    React.createElement(ODInputGuideText, { text: guideText, error: cnProps.error })
  )
}
//# sourceMappingURL=ODInput.js.map
